// Build an availableProperties structure from property metadata Maps,
// matching the shape returned by the cloud accessibleproperties endpoint:
// { Products: { vendorId: { Properties: [{Name: "..."}] } } }
//
// Both arguments tolerate being absent, because the initial data load
// degrades a blocked or failing endpoint to an empty fallback rather than
// failing the whole page. With no free product list nothing is marked free,
// which is the safe direction: a property shows as paid until the catalogue
// says otherwise.
export function buildFreePropertiesFromMaps(properties, freeProducts) {
    var products = {};
    var free = freeProducts || [];
    (properties || []).forEach(function (prop) {
        var isFree = prop.Maps && prop.Maps.some(function (m) {
            return free.indexOf(m) !== -1;
        });
        if (isFree) {
            var vendorId = prop.VendorId;
            if (!products[vendorId]) {
                products[vendorId] = { Properties: [] };
            }
            var propName = prop.Id.split('.').slice(1).join('.');
            products[vendorId].Properties.push({ Name: propName });
        }
    });
    return { Products: products };
}
